// @flow

import * as React from 'react';
import { downloadUpcoming, uploadUpcoming } from 'app/api/challenges';
import CSVPage from './CSVPage';

type Props = {
  onRedirect: () => void
};

function BatchEditLineup({ onRedirect }: Props) {
  return (
    <CSVPage
      downloadButtonLabel="Download Entries CSV"
      downloadFunc={downloadUpcoming}
      fileName="Entries"
      uploadFunc={uploadUpcoming}
      uploadLabel="Upload Edited Entries"
      onRedirect={onRedirect}
    />
  );
}

export default BatchEditLineup;
